import { useState } from "react";
import StuImage1 from "../../assets/pic4.jpg";
import StuImage2 from "../../assets/pic6.jpg";

const HeroSection = ({ activeTab = "student" }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const textColor = activeTab === "student" ? "text-black" : "text-black";
  const [isWhatsAppDialogOpen, setIsWhatsAppDialogOpen] = useState(false);

  // Form submission handler
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    // Map form fields to Google Form entry IDs
    const googleFormData = new FormData();
    googleFormData.append("entry.271377800", formData.get("name")); // Name
    googleFormData.append("entry.1059613645", formData.get("mobile")); // Mobile
    if (activeTab === "student") {
      googleFormData.append("entry.505168970", formData.get("locality")); // Locality
      googleFormData.append("entry.2115027460", formData.get("classGrade")); // Class/Grade
    } else {
      googleFormData.append("entry.1361867851", formData.get("email")); // Email
      googleFormData.append("entry.1272021577", formData.get("qualification")); // Qualification/Occupation
    }
    googleFormData.append(
      "entry.2132025188",
      activeTab === "student" ? "Student" : "Tutor"
    ); // Student/Teacher

    fetch(
      "https://docs.google.com/forms/u/0/d/e/1FAIpQLSdx-qrrSiMnzAhTbAaxU7UJfj0aZJlyPgCl3smjVFaWh4k-xA/formResponse",
      {
        method: "POST",
        body: googleFormData,
        mode: "no-cors",
      }
    )
      .then(() => {
        setIsDialogOpen(true);
        form.reset();
      })
      .catch((error) => console.error("Form submission error:", error));
  };

  return (
    <section
      className="min-h-screen w-full bg-slate-950 grid place-content-center top-0 overflow-hidden relative"
      style={{
        backgroundImage: `url(${
          activeTab === "student" ? StuImage1 : StuImage2
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="absolute top-0 left-0 w-full h-full z-0"></div>
      <div className="absolute bottom-0 left-0 w-full h-full z-10"></div>
      <div className="relative z-20 px-4 sm:px-6 md:px-8 mx-16">
        <div className="flex flex-col lg:flex-row gap-8 items-center lg:items-start mt-16 sm:mt-0">
          <div className="text-center lg:text-left mt-20 lg:mt-16 lg:mr-10">
            <h1
              className={`text-4xl sm:text-5xl md:text-5xl lg:text-6xl 2xl:text-7xl font-bold tracking-tight leading-tight animate-fadeIn ${textColor}`}
            >
              {activeTab === "student"
                ? "Unlock Your Potential with Home Tutoring"
                : "Empower Minds as a Home Tutor"}
            </h1>
            <p
              className={`text-base sm:text-lg md:text-xl mt-2 sm:mt-4 md:mt-6 ${
                activeTab === "student" ? "text-gray-700" : "text-gray-700"
              }`}
            >
              {activeTab === "student"
                ? "Trusted by over 1M+ students for personalized academic success."
                : "Join Tutor Kendra to connect with students and share your expertise."}
            </p>
            <div className="mt-6 sm:mt-8 space-y-4">
              <div className="">
                {activeTab === "student" ? (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                      type="hidden"
                      name="studentTeacher"
                      value="Student"
                    />
                    <div className="flex flex-col sm:flex-row gap-4">
                      <div className="flex-2">
                        <input
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                          required
                        />
                      </div>
                      <div className="flex-1">
                        <input
                          type="text"
                          name="mobile"
                          placeholder="+91 Enter mobile number"
                          className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-4">
                      <div className="flex-2">
                        <input
                          type="text"
                          name="locality"
                          placeholder="Enter your address"
                          className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                          required
                        />
                      </div>
                      <div className="flex-1">
                        <input
                          type="text"
                          name="classGrade"
                          placeholder="Enter Class/Grade"
                          className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="min-w-[250px] w-auto px-6 py-3 mx-0 bg-blue-500 text-white rounded-3xl hover:bg-blue-600"
                    >
                      Book Now
                    </button>
                  </form>
                ) : (
                  <div className="space-y-4">
                    <form onSubmit={handleSubmit} className="space-y-4">
                      <input
                        type="hidden"
                        name="studentTeacher"
                        value="Tutor"
                      />
                      <div className="flex flex-col sm:flex-row gap-4">
                        <div className="flex-2">
                          <input
                            type="text"
                            name="name"
                            placeholder="Enter your name"
                            className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <input
                            type="text"
                            name="mobile"
                            placeholder="+91 Enter mobile number"
                            className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                            required
                          />
                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-4">
                        <div className="flex-2">
                          <input
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-700"
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <select
                            name="qualification"
                            className="w-[270px] px-4 py-3 rounded-3xl bg-white text-black border drop-shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                          >
                            <option value="" disabled selected>
                              Select Qualification
                            </option>
                            <option value="12th">12th</option>
                            <option value="graduation">Graduation</option>
                            <option value="post-graduation">
                              Post-Graduation
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-4">
                        <div className="flex-2">
                          <button
                            type="submit"
                            className="w-[270px] mx-auto px-6 py-3 bg-blue-500 text-white rounded-3xl hover:bg-blue-600"
                          >
                            Register as Tutor
                          </button>
                        </div>
                        <div className="flex-2">
                          <button
                            onClick={() => setIsWhatsAppDialogOpen(true)}
                            className="w-[270px] mx-auto px-4 py-2 sm:px-6 sm:py-3 bg-green-600 text-white rounded-3xl hover:bg-green-700 transition-all max-w-xs"
                          >
                            Join WhatsApp Channel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="relative flex flex-col justify-center md:justify-end lg:ml-12">
            <div className="relative w-64 h-64 sm:w-80 sm:h-72 md:w-[500px] lg:h-[400px] md:block hidden"></div>
            <div className="relative my-8 block md:hidden">
              <div className="flex bg-white/50 backdrop-blur-md shadow-2xl rounded-xl p-4 md:p-6 items-center">
                {/* Telephone SVG */}
                <div className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="w-12 h-12 md:w-16 md:h-16"
                    style={{ enableBackground: "new 0 0 512 512" }}
                    xmlSpace="preserve"
                  >
                    <path
                      style={{ fill: "#e07188" }}
                      d="M406.187 44.373H105.813c-45.243 0-81.92 36.677-81.92 81.92v40.96h122.88V112.64h218.453v54.613h122.88v-40.96c.001-45.243-36.676-81.92-81.919-81.92z"
                    />
                    <path
                      style={{ fill: "#dc4161" }}
                      d="M92.16 112.64h54.613v54.613H92.16zM406.187 44.373h-54.613c45.243 0 81.92 36.677 81.92 81.92v40.96h54.613v-40.96c0-45.243-36.677-81.92-81.92-81.92z"
                    />
                    <path
                      style={{ fill: "#dc4161" }}
                      d="M10.24 153.6h150.187v54.613H10.24z"
                    />
                    <path
                      style={{ fill: "#e02753" }}
                      d="M92.16 153.6h68.267v54.613H92.16z"
                    />
                    <path
                      style={{ fill: "#dc4161" }}
                      d="M351.573 153.6H501.76v54.613H351.573z"
                    />
                    <path
                      style={{ fill: "#e02753" }}
                      d="M433.493 153.6h68.267v54.613h-68.267z"
                    />
                    <path
                      style={{ fill: "#ededed" }}
                      d="M228.693 167.253v-61.44c0-11.264-9.216-20.48-20.48-20.48-11.264 0-20.48 9.216-20.48 20.48v61.44h40.96zM324.267 167.253v-61.44c0-11.264-9.216-20.48-20.48-20.48-11.264 0-20.48 9.216-20.48 20.48v61.44h40.96z"
                    />
                    <path
                      style={{ fill: "#e07188" }}
                      d="M160.427 208.213V153.6h191.147v54.613c75.405 0 136.533 61.127 136.533 136.533v122.88H23.893v-122.88c0-75.405 61.128-136.533 136.534-136.533z"
                    />
                    <path
                      style={{ fill: "#dc4161" }}
                      d="M351.573 208.213V153.6h-68.267v54.613c75.405 0 136.533 61.127 136.533 136.533v122.88h68.267v-122.88c.001-75.405-61.128-136.533-136.533-136.533z"
                    />
                    <circle
                      style={{ fill: "#ededed" }}
                      cx="256"
                      cy="317.44"
                      r="95.573"
                    />
                    <path
                      style={{ fill: "#d8d8da" }}
                      d="M256 221.867c-7.033 0-13.88.781-20.48 2.223 42.938 9.378 75.093 47.6 75.093 93.351s-32.155 83.972-75.093 93.351a95.828 95.828 0 0 0 20.48 2.223c52.784 0 95.573-42.79 95.573-95.573S308.784 221.867 256 221.867z"
                    />
                    <circle
                      style={{ fill: "#797781" }}
                      cx="256"
                      cy="317.44"
                      r="20.48"
                    />
                    <path
                      style={{ fill: "#2e2d31" }}
                      d="M501.76 143.36h-3.413v-17.067c0-50.818-41.342-92.16-92.16-92.16h-245.76c-5.657 0-10.24 4.585-10.24 10.24s4.583 10.24 10.24 10.24h245.76c39.524 0 71.68 32.155 71.68 71.68v17.067h-102.4v-30.72c0-5.655-4.583-10.24-10.24-10.24h-30.914c-1.704-15.338-14.741-27.307-30.526-27.307s-28.822 11.969-30.526 27.307H238.74c-1.704-15.338-14.742-27.307-30.526-27.307s-28.822 11.969-30.526 27.307h-30.914c-5.657 0-10.24 4.585-10.24 10.24v30.72h-102.4v-17.067c0-39.525 32.156-71.68 71.68-71.68 5.657 0 10.24-4.585 10.24-10.24s-4.583-10.24-10.24-10.24c-50.818 0-92.16 41.342-92.16 92.16v17.067H10.24C4.583 143.36 0 147.945 0 153.6v54.613c0 5.655 4.583 10.24 10.24 10.24h75.485c-43.11 25.597-72.072 72.623-72.072 126.293v122.88c0 5.655 4.583 10.24 10.24 10.24h464.213c5.657 0 10.24-4.585 10.24-10.24s-4.583-10.24-10.24-10.24H34.133v-112.64c0-69.639 56.655-126.293 126.293-126.293 5.657 0 10.24-4.585 10.24-10.24V163.84h170.667v44.373c0 5.655 4.583 10.24 10.24 10.24 69.639 0 126.293 56.654 126.293 126.293v68.267c0 5.655 4.583 10.24 10.24 10.24s10.24-4.585 10.24-10.24v-68.267c0-53.67-28.961-100.696-72.072-126.293h75.485c5.657 0 10.24-4.585 10.24-10.24V153.6c.001-5.655-4.582-10.24-10.239-10.24zm-262.827-20.48h34.133v20.48h-34.133v-20.48zM20.48 163.84h129.707v34.133H20.48V163.84zm136.533-20.48v-20.48h20.48v20.48h-20.48zm40.96 0v-37.547c0-5.647 4.593-10.24 10.24-10.24s10.24 4.593 10.24 10.24v6.801l-.001.026.001.026v30.694h-20.48zm95.574 0v-37.547c0-5.647 4.593-10.24 10.24-10.24s10.24 4.593 10.24 10.24v37.547h-20.48zm40.96 0v-20.48h20.48v20.48h-20.48zm157.013 54.613H361.813V163.84H491.52v34.133z"
                    />
                    <path
                      style={{ fill: "#2e2d31" }}
                      d="M256 211.627c-58.345 0-105.813 47.467-105.813 105.813S197.655 423.253 256 423.253s105.813-47.467 105.813-105.813S314.345 211.627 256 211.627zm0 191.146c-47.053 0-85.333-38.281-85.333-85.333s38.28-85.333 85.333-85.333 85.333 38.281 85.333 85.333-38.28 85.333-85.333 85.333z"
                    />
                    <path
                      style={{ fill: "#2e2d31" }}
                      d="M256 286.72c-16.938 0-30.72 13.78-30.72 30.72 0 16.94 13.782 30.72 30.72 30.72s30.72-13.78 30.72-30.72c0-16.94-13.782-30.72-30.72-30.72zm0 40.96c-5.647 0-10.24-4.593-10.24-10.24s4.593-10.24 10.24-10.24 10.24 4.593 10.24 10.24-4.593 10.24-10.24 10.24z"
                    />
                  </svg>
                </div>

                {/* Text Content */}
                <div>
                  <p className="font-light text-base md:text-xl">
                    Need Help? Call Us On
                  </p>
                  <p className="text-sm">
                    <a
                      href="tel:+916388204164"
                      className="font-bold text-3xl transition-colors inline-block"
                    >
                      +916388204164
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Dialog */}
      {isDialogOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-2xl animate-fadeIn">
            {/* <h2 className="text-2xl font-bold text-blue-600 mb-4">
              Hooray, You Did It!
            </h2> */}
            <p className="text-gray-700 mb-6">
              Thank you. Your details have been successfully submitted, and
              Tutor Kendra team will contact you shortly.
            </p>
            <button
              onClick={() => setIsDialogOpen(false)}
              className="w-full px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-all"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* WhatsApp Channel Selection Dialog */}
{isWhatsAppDialogOpen && (
  <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
    <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-2xl animate-fadeIn">
      <h2 className="text-2xl font-bold text-green-600 mb-4">
        Select Your City
      </h2>
      <p className="text-gray-700 mb-6">
        Choose your city to join the relevant WhatsApp channel:
      </p>
      
      <div className="space-y-3 mb-6">
        <CityOption 
          city="Varanasi" 
          link="https://whatsapp.com/channel/0029Vb9NgOKFnSz9TesD9R0q" 
        />
        <CityOption 
          city="Lucknow" 
          link="https://whatsapp.com/channel/0029VbBM7jvC6ZveBtP29g41" 
        />
        <CityOption 
          city="Prayagraj" 
          link="https://whatsapp.com/channel/0029VbBreWS8V0tpWAkHAu1x" 
        />
      </div>
      
      <button
        onClick={() => setIsWhatsAppDialogOpen(false)}
        className="w-full px-4 py-2 bg-gray-300 text-gray-700 rounded-3xl hover:bg-gray-400 transition-all"
      >
        Cancel
      </button>
    </div>
  </div>
)}
    </section>
  );
};

const CityOption = ({ city, link }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full px-4 py-3 bg-green-100 text-green-800 rounded-xl hover:bg-green-200 transition-all text-center font-medium"
    >
      {city}
    </a>
  );
};

export default HeroSection;
